import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";

import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
@Component({
  standalone: true,
  selector: "app-faq-modal",
  imports: [MatDialogModule, MatIcon],
  templateUrl: "./faq-modal.component.html",
  styleUrl: "./faq-modal.component.scss",
})
export class FAQModalComponent {
  faqLink: SafeResourceUrl;
  constructor(
    private dialogRef: MatDialogRef<FAQModalComponent>,
    @Inject(MAT_DIALOG_DATA) public url: string,
    private sanitizer: DomSanitizer
  ) {
    // Sanitize the URL
    this.faqLink = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
